const courses = {
  state: () => ({
    schools: [
      {
        title: "Pluralsight",
        courses: [
          {
            title: "Vue JS: Big Picture",
            link:
              "https://app.pluralsight.com/library/courses/vuejs-big-picture/table-of-contents",
            author: "Daniel Stern"
          },
          {
            title: "Vue.js Playbook",
            link: "https://app.pluralsight.com/library/courses/vuejs-playbook",
            author: "Chad Campbell"
          },
          {
            title: "Vue.js Fundamentals",
            link:
              "https://app.pluralsight.com/library/courses/vuejs-fundamentals/table-of-contents",
            author: "Jim Cooper"
          },
          {
            title: "React Getting Started",
            link:
              "https://app.pluralsight.com/library/courses/react-js-getting-started/table-of-contents",
            author: "Samer Buna"
          },
          {
            title: "Adding Graphics to Web Pages Using Canvas and SVG",
            link:
              "https://app.pluralsight.com/library/courses/adding-graphics-web-pages-using-canvas-svg/table-of-contents",
            author: "Michael Van Sickle"
          },
          {
            title: "Vue 3.0 Better, Faster, and Stronger",
            link:
              "https://app.pluralsight.com/library/courses/codemash-session-52/table-of-contents",
            author: "CodeMash"
          },
          {
            title: "Javascript Generators and Iterators",
            link:
              "https://app.pluralsight.com/library/courses/javascript-generators-iterators/table-of-contents",
            author: "Marques Woodson"
          },
          {
            title: "Vue: Getting Started",
            link:
              "https://app.pluralsight.com/library/courses/vue-getting-started/table-of-contents",
            author: "John Papa"
          }
        ]
      },
      {
        title: "Scrimba",
        courses: [
          {
            title: "Learn React",
            link: "https://scrimba.com/course/glearnreact/",
            author: "Bob Ziroll"
          },
          {
            title: "Learn Vuex",
            link: "https://scrimba.com/course/gvuex/",
            author: "Connor Lindsey"
          },
          {
            title: "Learn React Hooks",
            link: "https://scrimba.com/course/greacthooks/",
            author: "Christian Jensen"
          },
          {
            title: "Learn UI Design Fundamentals",
            link: "https://scrimba.com/course/gdesign/",
            author: "Gary Simon"
          },
          {
            title: "Learn Svelte",
            link: "https://scrimba.com/course/glearnsvelte/",
            author: "Noah Kaufman"
          },
          {
            title: "Learn Alpine JS",
            link: "https://scrimba.com/course/galpinejs/",
            author: "Andre Madarang"
          },
          {
            title: "The Coding Bootcamp Primer",
            link: "https://scrimba.com/course/gbootcampprimer/",
            author: "V School"
          },
          {
            title: "Build Tic Tac Toe with React Hooks",
            link: "https://scrimba.com/course/greactgame/",
            author: "Thomas Weibenfalk"
          },
          {
            title: "Learn Tailwind CSS",
            link: "https://scrimba.com/course/gtailwind/",
            author: "Victor Gonzalez"
          },
          {
            title: "Build and deploy a portfolio",
            link: "https://scrimba.com/course/gportfolio/",
            author: "Kevin Powell"
          },
          {
            title: "The Working Developer's Guide To Algorithms",
            link: "https://scrimba.com/course/galgorithmsguide/",
            author: "Jonathan Lee Martin"
          },
          {
            title: "Learn CSS Animations",
            link: "https://scrimba.com/course/gcssanimations/",
            author: "Jad Khalili"
          },
          {
            title: "Build an app with React and GraphQL",
            link: "https://scrimba.com/course/greactgraphql/",
            author: "Karl Hadwen"
          },
          {
            title: "Learn Vuetify",
            link: "https://scrimba.com/course/gvuetify/",
            author: "Gwen Faraday"
          },
          {
            title: "Build a movie search app in React",
            link: "https://scrimba.com/course/greactmovie/",
            author: "James Q Quick"
          }
        ]
      },
      {
        title: "Skillshare",
        courses: [
          {
            title:
              "The JavaScript Toolkit: Write Cleaner, Faster & Better Code",
            link:
              "https://www.skillshare.com/classes/The-JavaScript-Toolkit-Write-Cleaner-Faster-Better-Code/",
            author: "Christian Heilmann"
          },
          {
            title: "Full Stack Web Developer in 2020",
            link:
              "https://www.skillshare.com/classes/Full-Stack-Web-Developer-in-2020/",
            author: "Andrei Neagoie"
          },
          {
            title: "ReactJS and Redux - Build 4 Web Apps",
            link:
              "https://www.skillshare.com/classes/ReactJS-and-Redux-Build-4-Web-Apps-14/",
            author: "David Katz"
          },
          {
            title: "Vue.js 2 Academy: Learn Vue Step by Step",
            link:
              "https://www.skillshare.com/classes/Vue-js-2-Academy-Learn-Vue-Step-by-Step/",
            author: "Chris Dixon"
          },
          {
            title: "The Vue JS Crash Course",
            link: "https://www.skillshare.com/classes/The-Vue-JS-Crash-Course/",
            author: "Stephen Sparling"
          },
          {
            title: "CSS Masterclass",
            link:
              "https://www.skillshare.com/classes/CSS-Masterclass-the-only-CSS-course-youll-ever-need-to-take/1912713660/",
            author: "Kalob Taulien"
          }
        ]
      },
      {
        title: "StackSkills",
        courses: [
          {
            title: "Python Fundamentals",
            link: "https://stackskills.com/courses/394191",
            author: "Sanjin Dedic"
          },
          {
            title: "The Web Developer Bootcamp",
            link: "https://stackskills.com/courses/657303",
            author: "Colt Steele"
          },
          {
            title: "Angular 2 Crash Course",
            link: "https://stackskills.com/courses/80405",
            author: "Stone River eLearning"
          },
          {
            title: "Javascript Bible",
            link: "https://stackskills.com/courses/462105",
            author: "Bogdan Stashchuk"
          },
          {
            title: "The Complete Python Course",
            link: "https://stackskills.com/courses/102831",
            author: "Joseph Delgadillo "
          }
        ]
      },
      {
        title: "Vue Mastery",
        courses: [
          {
            title: "Unit Testing",
            link: "https://www.vuemastery.com/courses/unit-testing/",
            author: "Vue Mastery"
          },
          {
            title: "Intro to Vue 3",
            link: "https://www.vuemastery.com/courses/intro-to-vue-3/",
            author: "Vue Mastery"
          },
          {
            title: "Animating Vue",
            link: "https://www.vuemastery.com/courses/animating-vue/",
            author: "Vue Mastery"
          },
          {
            title: "Intro to Vue.js",
            link: "https://www.vuemastery.com/courses/intro-to-vue-js/",
            author: "Vue Mastery"
          }
        ]
      },
      {
        title: "Vue School",
        courses: [
          {
            title: "Vuex for Everyone",
            link: "https://vueschool.io/courses/vuex-for-everyone",
            author: "Vue School"
          },
          {
            title: "Internationalization with vue-i18n",
            link:
              "https://vueschool.io/courses/internationalization-with-vue-i18n",
            author: "Vue School"
          },
          {
            title: "Vue Router for Everyone",
            link: "https://vueschool.io/courses/vue-router-for-everyone",
            author: "Vue School"
          },
          {
            title: "Vue.js Components Fundamentals",
            link: "https://vueschool.io/courses/vuejs-components-fundamentals",
            author: "Vue School"
          },
          {
            title: "Nuxt.js Fundamentals",
            link: "https://vueschool.io/courses/nuxtjs-fundamentals",
            author: "Vue School"
          },
          {
            title: "JavaScript Testing Fundamentals",
            link:
              "https://vueschool.io/courses/javascript-testing-fundamentals",
            author: "Vue School"
          },
          {
            title: "Vue.js Fundamentals",
            link: "https://vueschool.io/courses/vuejs-fundamentals",
            author: "Vue School"
          }
        ]
      },
      {
        title: "Wes Bos",
        courses: [
          {
            title: "Javascript 30 days Coding Challenge",
            link: "https://javascript30.com/",
            author: "Wes Bos"
          },
          {
            title: "CSS Grid",
            link: "https://cssgrid.io/",
            author: "Wes Bos"
          },
          {
            title: "What the Flexbox?!",
            link: "https://flexbox.io/",
            author: "Wes Bos"
          },
          {
            title: "Command Line Power",
            link: "https://commandlinepoweruser.com/",
            author: "Wes Bos"
          },
          {
            title: "Learn Redux",
            link: "https://learnredux.com/",
            author: "Wes Bos "
          }
        ]
      }
    ]
  })
};

export default courses;
